import { RootState } from '@atredux/store'

export const getAccessToken = (state: RootState): string => state.ihmLoginTokenInfo._ihmLoginToken

export const getIIBRefreshToken = (state: RootState): string => state.ihmLoginTokenInfo._ihmIIBRefreshToken

export const getIdToken = (state: RootState): string => state.ihmLoginTokenInfo._ihmLoginIdToken

export const getIIBIdToken = (state: RootState): string => state.ihmLoginTokenInfo._ihmIIBIdToken

export const getTokenType = (state: RootState): string => state.ihmLoginTokenInfo._tokenType

export const getScopes = (state: RootState): string => state.ihmLoginTokenInfo._ihmLoginTokenScopes

export const getIsLoggedIn = (state: RootState): boolean => state.ihmLoginTokenInfo._isLoggedIn
